import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the RgbProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RgbProvider {

  constructor(public http: HttpClient) {
    
  }

  rgbMulticolor(){
    let r = Math.floor(Math.random() * 200) + 50;  // 0*204 + 50 = 
    let g = Math.floor(Math.random() * 200) + 50;
    let b = Math.floor(Math.random() * 200) + 50;
    let transparencia= 0.6;
    let colores={ 
      color:"rgba("+ r + ","+ g +","+ b +","+ transparencia +")",
      bgcolor:"rgba("+ r + ","+ g +","+ b +","+ 1 +")"
    };
    return colores;
  }

  rgbTono(){
    let valorMax=250; //160 min
    let limiteMin=100; // 30 min      
    let r= Math.floor(Math.random() * (limiteMin-30)) + 30;    
    let b=Math.floor(Math.random()* (valorMax-130))+130;   
    let g=Math.floor(Math.random()* (b-r))+r;    
    let transparencia= 0.6;
    let colores={ 
      color:"rgba("+ r + ","+ g +","+ b +","+ transparencia +")",
      bgcolor:"rgba("+ r + ","+ g +","+ b +","+ 1 +")"
    };
    return colores;
  }

  // Paleta fija para reportes: conserva el color de cada posición al refrescar
  // el mismo reporte y evita que la lectura visual cambie entre cargas.
  rgbReporte(indice: number){
    const paleta = [
      { color: 'rgba(20, 144, 183, 0.72)', bgcolor: 'rgba(20, 144, 183, 1)' },
      { color: 'rgba(43, 123, 165, 0.72)', bgcolor: 'rgba(43, 123, 165, 1)' },
      { color: 'rgba(53, 166, 153, 0.72)', bgcolor: 'rgba(53, 166, 153, 1)' },
      { color: 'rgba(241, 157, 68, 0.72)', bgcolor: 'rgba(241, 157, 68, 1)' },
      { color: 'rgba(119, 101, 185, 0.72)', bgcolor: 'rgba(119, 101, 185, 1)' },
      { color: 'rgba(214, 95, 111, 0.72)', bgcolor: 'rgba(214, 95, 111, 1)' },
      { color: 'rgba(91, 151, 82, 0.72)', bgcolor: 'rgba(91, 151, 82, 1)' },
      { color: 'rgba(97, 111, 130, 0.72)', bgcolor: 'rgba(97, 111, 130, 1)' }
    ];
    return paleta[indice % paleta.length];
  }

}



// WEBPACK FOOTER //
// ./src/providers/rgb/rgb.ts